import { Avatar } from 'antd';
import './header-actions.css';

interface UserProfileProps {
  avatarImg: string | undefined;
  userName: string;
  onClick?: () => void;
}

const UserProfile: React.FC<UserProfileProps> = ({
  userName,
  onClick,
  avatarImg,
}) => {
  return (
    <div
      className="header-action-component user-profile trojan-neumorphism-box trojan-neumorphism-box-shadow"
      onClick={onClick}
    >
      <div className="user-profile-avatar">
        <Avatar size={24} src={avatarImg}>
          U
        </Avatar>
        <div className="avatar-status" />
      </div>
      <span title={userName} className="user-name">
        {userName}
      </span>
    </div>
  );
};

export default UserProfile;
